import {
  useFloorPriceQuery,
  useSharedFloorPriceQuery
} from "shared/api/price/queries.generated"

export function useFloorPrice({
  floorID,
  projectID,
  isShared,
  isPending
}: {
  floorID: string
  projectID?: string
  isShared?: boolean
  isPending?: boolean
}) {
  const {
    data: floorPriceData,
    loading: isFloorPriceLoading,
    error: floorPriceError
  } = useFloorPriceQuery({
    variables: { id: floorID },
    skip: isShared || isPending
  })

  const {
    data: sharedFloorPriceData,
    loading: isSharedFloorPriceLoading,
    error: sharedFloorPriceError
  } = useSharedFloorPriceQuery({
    variables: { projectShareID: projectID || "", floorID },
    skip: !isShared || !projectID || isPending
  })

  return {
    price: isShared
      ? sharedFloorPriceData?.sharedFloorPrice
      : floorPriceData?.floorPrice,
    isLoading: isShared
      ? isSharedFloorPriceLoading ||
        (!sharedFloorPriceError &&
          !sharedFloorPriceData?.sharedFloorPrice?.isValid)
      : isFloorPriceLoading ||
        (!floorPriceError && !floorPriceData?.floorPrice?.isValid),
    error: isShared ? sharedFloorPriceError : floorPriceError
  }
}
